import { put, takeEvery, call } from 'redux-saga/effects';
import { getType } from 'deox';
import { Transition } from 'types/Transitions';
import { loadTransitions, setTransitionList } from 'modules/transitions';
import { getTransitionsData } from 'utils/apiWrapper';
import { addAlert } from 'modules/alert';
import { transitionMessages } from 'constants/errorMessages';
import ErrorLogger from '../../components/ErrorLogger';

export function* loadTransitionsSaga() {
  try {
    const data: Transition[] = yield call(getTransitionsData);
    yield put(setTransitionList(data));
  } catch (e) {
    ErrorLogger.trigger(e);
    yield put(addAlert(transitionMessages.title, transitionMessages.loadingError));
  }
}

export default function* transitionSaga() {
  yield takeEvery(getType(loadTransitions), loadTransitionsSaga);
}
